// src/components/Layout.jsx
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { useAuth } from "../context/AuthContext";

export default function Layout() {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate()
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setSidebarOpen((s) => !s);
  const closeSidebar = () => setSidebarOpen(false);
  const toggleSidebarCollapse = () => setIsSidebarCollapsed((c) => !c);

  useEffect(() => {
    if (location.pathname == "/" && isAuthenticated) {
      navigate("/pages")
    }
  }
    , [location.pathname]);

    useEffect(()=>{
      if(isAuthenticated){
        login(false)
      }
    },[])
  return (
    <div className={`layout ${sidebarOpen ? "sidebar-open" : ""} ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={closeSidebar} 
        isCollapsed={isSidebarCollapsed} 
        onToggleCollapse={toggleSidebarCollapse} 
      />
      <div
        className="layout-content"
        // clicking the main content should close the sidebar on mobile
        onClick={() => {
          if (sidebarOpen) closeSidebar();
        }}
      >
        {/* pass toggleSidebar & sidebarOpen via Outlet context */}
        <Outlet context={{ toggleSidebar, closeSidebar, sidebarOpen, isSidebarCollapsed, toggleSidebarCollapse }} />
      </div>
    </div>
  );
}
